import constants from '@constants'

const ArrowRight = ({ ...props }) => {
  return constants.BRAND === 'sports-research' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 60 60"
      {...props}
    >
      <circle cx="30" cy="30" r="30" fill="currentColor" />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="3"
        d="m33 21-9 9 9 9"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 63 62"
      {...props}
    >
      <circle
        cx="31.5"
        cy="31"
        r="29.5"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        stroke="currentColor"
        strokeWidth="2.25"
        d="M39 31H22.5M29.25 37.75 22.5 31l6.75-6.75"
      />
    </svg>
  )
}

export default ArrowRight
